import axios, { AxiosResponse } from "axios";
import { GroupItem, Item, Variant } from "BrokerTsLib/src/dtos";
import { longStaleTime } from "BrokerTsLib/src/hooks";
import { UseQueryResult, useQuery } from "react-query";
import { GenericQueryOptions, useUrl } from ".";
import { PackageItemTypeCategory, Risk, RiskVariant } from "BrokerTsLib/src/enums";

export const useGetRisks = (options?: GenericQueryOptions<GroupItem[]>): UseQueryResult<AxiosResponse<GroupItem[], any>, any> => {
    const url = useUrl()

    return useQuery(['GetRisks', 'property'], () =>
        axios.get<Item[]>(`${url}/GetRisks`), { staleTime: longStaleTime, ...options })
}

export const useGetGroupedRisks = (variant: Variant, ignoreRiskIds?: Risk[]) => {
    const { data } = useGetRisks({ refetchOnWindowFocus: false, refetchOnMount: false })

    const risks = data?.data ?? []
    const typeRiskVariant = variant.variantParts?.find(x => x.risk == Risk.PROPERTY_TYPE)?.riskVariant

    const result = risks
        .filter(x => {
            if (!typeRiskVariant || typeRiskVariant == RiskVariant.HouseholdAndRealty) return true
            if (typeRiskVariant == RiskVariant.Household) return Number(x.groupId) != PackageItemTypeCategory.Realty
            if (typeRiskVariant == RiskVariant.Realty) return Number(x.groupId) != PackageItemTypeCategory.Household

            console.log('Invalid variant', variant)
            return false
        })
        .filter(x => !ignoreRiskIds || !ignoreRiskIds.includes(x.id))
        .reduce((pv, cv) => {
            return {
                ...pv,
                [cv.groupOrder ?? '']: [...(pv[cv.groupOrder ?? ''] ?? []), cv]
            }
        }, {} as { [n: string]: GroupItem[] })

    return result
}